import React, { useState, useEffect } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import MotionWrapper from '../../component/MotionWrapper';
import axios from 'axios';
import Letter from '../../component/Spring/Letter';
import Dday_Spring from '../../component/Spring/Dday_Spring';
import Message_Spring from '../../component/Spring/Message_Spring';
import Location_Spring from '../../component/Spring/Location_Spring';
import Footer from '../../component/Footer';
import Loading from '../../component/Loading';
import Location_Desc from '../../component/Location/Location_Desc';
import Music from '../../component/Music';
import AccountList from '../../component/Account/AccountList';
import Sharing from '../../component/Sharing';
import GalleryList from '../../component/Gallery/GalleryList';
import Main_Summer from '../../component/Summer/Main_Summer';
import Save_Date from '../../component/Save_Date';
import Info_Spring from '../../component/Spring/Info_Spring';
import Interview_Spring from '../../component/Spring/Interview_Spring';
import CallInfo from '../../component/CallInfo';
import Information from '../../component/Information';
import Info_Spring2 from '../../component/Spring/Info_Spring2';
import AccountList2 from '../../component/Account/AccountList2';


const JeongSuYeon = () => {
    const navigate = useNavigate(); 
    const { mainPage } = useParams();

    const API_URL = process.env.REACT_APP_API_URL;

    const [loading, setLoading] = useState(true);
    const [fontsLoaded, setFontsLoaded] = useState(false);

    const openTitle = "장성영♥정수연 결혼합니다.";
    const openDesc = "2025년 8월 9일 토요일 오전 11시 \n더빈컨벤션 4F 그랜드볼룸";
    const openThumb = "https://d39wt6wnedokd1.cloudfront.net/262/thumb.jpg";

    const lng = 127.384089131576;
    const lat = 36.6321658604229;

    const placeTelNum = "043-238-2222";

    const forCar = "청주IC, 서청주IC에서 약 5분";
    const forTrain2 = "- 청주역\n택시 이용시 (소요시간 약 5~10분)\n\n- 조치원역, 오송KTX역\n500,503,509,747번 버스 탑승 (청주 방면) / \n충청대학교에서 하차 후 충청대 사거리\n‘우림조경건설’ 앞에서 500,514번 이용";
    const forBus = "학천리 또는 더빈컨벤션 정류장 하차\n노선번호 : 500, 514번";

    const [weddingData, setWeddingData] = useState({
        id:'',
        concept: '',
        weddingDate: '',
        invitationInfoId: '',
        brideName: '',
        groomName: '',
        brideNameEn: '',
        groomNameEn: '',
        year:'',
        month:'',
        date:'',
        dayOfWeek:'',
        time:'',
        place:'',
        address:'',
        mainImg:'',
        subImg:'',
        pointColor: '',
        btnFontColor: '',
        btnBgColor: '',
        isGuestBookOpen: ''
    });


    const conceptStyle = {
        // summer 블랙
        concept: "SUMMER",
        titleColor: "#000000",
        pointColor: "#000000",
        btnBgColor: "#212121",
        fontColor: "#fff",
        btnFontColor: "#fff",
        chatBgColor: "#F5F8FF",
        fontFamilyKo: "SCDream3",
        fontFamilyEn: "Edensor"
    }

    const title = "우리 결혼합니다."

    const msg1 = "함께 맞이하는 세 번째 여름\n곁에 있을 때 가장 나답게 만들어주는 사람과\n모든 순간을 함께 하려고 합니다.\n언제나처럼 평생의 친구이자\n서로에게 유일한 단 하나의 사랑이 되겠습니다.";
    const msg2 = "혼자가 아닌 우리로 빛나는 날,\n소중한 분들을 모십니다.";

    const parents = [
        {groom : "❁박금주 · 이윤실의 장남"},
        {bride : "이학두 · 최경숙의 차녀"}
    ]

    const groomAccountList = [
        {
            role: "신랑",
            name: "장성영",
            bank: "신한은행",
            accountNumber : "110-341-534957",
            isKakao : true,
            kakaoUrl : "https://qr.kakaopay.com/FGrj5jSvI"
        }
        ,{
            role: "신랑 부",
            name: "장병권",
            bank: "신한은행",
            accountNumber : "110-277-908392",
            isKakao : false
        }
        // ,{
        //     role: "신랑 모",
        //     name: "정연금",
        //     bank: "신한은행",
        //     accountNumber : "110-228-143248",
        //     isKakao : false
        // }
    ]

    const brideAccountList = [
        {
            role: "신부",
            name: "정수연",
            bank: "신한은행",
            accountNumber : "110-464-170400",
            isKakao : true,
            kakaoUrl : "https://qr.kakaopay.com/Ej8SY01mN"
        }
        ,{
            role: "신부 부",
            name: "정동우",
            bank: "농협",
            accountNumber : "304-12-362906",
            isKakao : false
        }
        // ,{
        //     role: "신부 모",
        //     name: "김다연",
        //     bank: "우리은행",
        //     accountNumber : "1002-929-183666",
        //     isKakao : false
        // }
    ]

    const account_explain = "따로 계좌번호를 여쭤보시는 수고를 덜기 위해 기입합니다. \n부담 안가지셨으면 좋겠습니다."

    const interviewContent = [
        {
            question : "처음 만났을 때 어땠어?",
            groomAnswer: "너무 떨렸어",
            brideAnswer: "잘 먹던데?"
        },
        {
            question : "어떤 점이 제일 마음에 들었어?",
            groomAnswer: "잘 먹는거?",
            brideAnswer: "반전 개그맨"
        },
        {
            question : "서로에게 하고 싶은 말은?",
            groomAnswer: "봉잡은줄알아",
            brideAnswer: "땡잡은줄알아"
        },
        {
            question : "유부남/녀 기념 각오 한마디!",
            groomAnswer: "회식줄일게",
            brideAnswer: "평소대로할게"
        },
        {
            question : "마지막으로 전하고 싶은 이야기는?",
            groomAnswer: "행복하자~",
            brideAnswer: "좋아좋아!"
        },
    ]

    const groomCallInfoList = [
        {
            role: "신랑",
            name: "장성영",
            call: "010-8001-7148"
        }
        // ,{
        //     role: "신랑 부",
        //     name: "이용우",
        //     call: "010-4103-1248"
        // }
        // ,{
        //     role: "신랑 모",
        //     name: "이영실",
        //     call: "010-7137-1248"
        // }
    ]

    const brideCallInfoList = [
        {
            role: "신부",
            name: "정수연",
            call: "010-9458-8031"
        }
        // ,{
        //     role: "신부 부",
        //     name: "조양주",
        //     call: "010-3789-6551"
        // }
        // ,{
        //     role: "신부 모",
        //     name: "박은영",
        //     call: "010-9040-6551"
        // }
    ]

    const informationList =[
        {
            title : "ATM 기기 안내",
            content : "주변엔 ATM기기가 없습니다. \n이점 양해 부탁드립니다."
        }
    ]

    const fetchInvitationInfoData = async () => {
        try {
            const response = await axios.get(`${API_URL}/_api/v1/invitation_info/${mainPage}`);
            if(response.status === 200){
                const [y, m, d] = response.data.data.weddingDate.split('-');

                setWeddingData(prevData => {
                    const newData = {
                        id: response.data.data.id,
                        concept: response.data.data.concept,
                        weddingDate: response.data.data.weddingDate,
                        invitationInfoId: response.data.data.id,
                        brideName: response.data.data.brideNameKo,
                        groomName: response.data.data.groomNameKo,
                        brideNameEn: response.data.data.brideNameEn,
                        groomNameEn: response.data.data.groomNameEn,
                        year: y,
                        month: m,
                        date: d,
                        dayOfWeek: response.data.data.dayOfWeek,
                        time: response.data.data.time,
                        place: response.data.data.place,
                        address: response.data.data.address,
                        mainImg: response.data.data.mainImg,
                        subImg: response.data.data.subImg,
                        pointColor: response.data.data.pointColor,
                        btnBgColor: response.data.data.btnBgColor,
                        btnFontColor: response.data.data.btnFontColor,
                        isGuestBookOpen: response.data.data.isGuestBookOpen
                    };
                    return newData;
                });
            } 
        } catch (error) {
            console.error("API 요청 실패:", error.response ? error.response.data : error.message);
        }
    };

    useEffect(() => {
        const fetchDataSequentially = async () => {
            if (!weddingData.weddingDate) {  
                await fetchInvitationInfoData();
            }
        };
        fetchDataSequentially();  
    
        document.body.style.overflow = 'hidden';
    
        const timer = setTimeout(() => {
            document.body.style.overflow = '';
        }, 3000);
    
        return () => {
            clearTimeout(timer);
            document.body.style.overflow = '';
        };
    }, []);

    useEffect(() => {
        const fontLoadObserver = async () => {
            await document.fonts.ready; 
            setFontsLoaded(true); 
            setLoading(false);
        };
        if(!weddingData.weddingDate){
            fontLoadObserver();
        }
    }, []);

    const goToGuestBook = () => {
        navigate(`/${mainPage}/guest`); 
    };

    // 성을 제외하고 이름만 추출 ex. 가영
    const getFirstKoName = (fullName) => {
        const nameParts = fullName.split(''); 
        return nameParts.slice(1).join(''); 
    };

    // 성을 제외하고 이름만 추출 ex.Gayeong
    const getFirstNameEn = (fullName) => {
        const nameParts = fullName.split(' '); 
        const firstName = nameParts.slice(1).join(''); 
        return firstName.charAt(0).toUpperCase() + firstName.slice(1).toLowerCase();
    };

    // ex. Kim Gayeong
    const getRemoveSpaceName = (fullName) => {
        const nameParts = fullName.split(' '); // 문자열을 띄어쓰기로 분리
        const firstName = nameParts[0]; // 첫 번째 단어 유지
        const restName = nameParts.slice(1).join(''); // 나머지 단어를 소문자로 변경하고 결합
        return firstName + ' ' + restName.charAt(0).toUpperCase() + restName.slice(1).toLowerCase();
    };

        // 성을 제외하고 이름만 추출 ex.Gayeong
        const getFirstEnName = (fullName) => {
            const nameParts = fullName.split(' '); 
            const firstName = nameParts.slice(1).join(''); 
            return firstName.charAt(0).toUpperCase() + firstName.slice(1).toLowerCase();
        };
        
        // 브라운 #5b0100
        // #761B40
        // #423866
        // #d98db9
        // #FF8A83
        // #76902F
        // #DF1C32
        // #b00c1f
//         #b00938
    return (
        <div>
            {loading || !fontsLoaded ? (
                <Loading color={"#000000"} loading={loading} />
            ) : (
                <>
                    <Music concept={conceptStyle.concept} />
                    <Main_Summer weddingData={weddingData} groomNameEn={getRemoveSpaceName(weddingData.brideNameEn)} brideNameEn={getRemoveSpaceName(weddingData.groomNameEn)} color={"#212121"} letteringFontColor={"#b00c1f"} dateColor={"#212121"} bottom={"82%"} bottom2={"72.5%"} dateBottom={"1%"} top={"2%"}/>
                    <Save_Date color={conceptStyle.pointColor} isBorder={true} marginTop={"100px"} marginBottom={"10px"} fontSize={"13px"} />
                    <Info_Spring2  weddingData={weddingData} conceptStyle={conceptStyle} brideNameEn={getFirstEnName(weddingData.brideNameEn)} groomNameEn={getFirstEnName(weddingData.groomNameEn)}/>
                    <Letter title={title} msg1={msg1} msg2={msg2} conceptStyle={conceptStyle} />
                    <CallInfo marginTop={"10px"} conceptStyle={conceptStyle} groomCallInfoList={groomCallInfoList} brideCallInfoList={brideCallInfoList}/>
                    <Dday_Spring isAttendFromClose={true} brideName={getFirstKoName(weddingData.brideName)} groomName={getFirstKoName(weddingData.groomName)} weddingData={weddingData} conceptStyle={conceptStyle}/>
                    <MotionWrapper initialY={50}>
                        <GalleryList fontFamilyKo={conceptStyle.fontFamilyKo} fontFamilyEn={conceptStyle.fontFamilyEn} color={conceptStyle.titleColor} weddingData={weddingData} initCount={6} photoWidth={"150px"} photoHeight={"235px"} gap={"4px"}/>
                    </MotionWrapper>
                    <MotionWrapper initialY={70}>
                        <AccountList conceptStyle={conceptStyle} groomAccountList={groomAccountList} brideAccountList={brideAccountList} account_explain={account_explain} />
                    </MotionWrapper>
                    <MotionWrapper initialY={70}>
                        <Message_Spring  weddingData={weddingData} goToGuestBook={goToGuestBook} weddingDate={weddingData.weddingDate} 
                            conceptStyle={conceptStyle} 
                            btnBgColor={weddingData.btnBgColor} btnFontColor={weddingData.btnFontColor} titleColor={weddingData.titleColor}
                            />
                    </MotionWrapper>
                    <MotionWrapper initialY={50}>
                        {/* <Interview_Spring interviewContent={interviewContent} weddingData={weddingData} conceptStyle={conceptStyle} /> */}
                        <Location_Spring weddingData={weddingData} conceptStyle={conceptStyle} lng={lng} lat={lat} placeTelNum={placeTelNum}/>
                    </MotionWrapper>
                    <Location_Desc isPoint={true} forCar={forCar} forBus={forBus} forTrain2={forTrain2} conceptStyle={conceptStyle}/>
                    <Sharing conceptStyle={conceptStyle} title={openTitle} description={openDesc} thumbImg={openThumb}/>
                    <Footer />
                </>
            )}
        </div>
    );
    
};

export default JeongSuYeon;